import { Calculator, RotateCcw } from "lucide-react";
import { fmt } from "@/data/vaseisFields";

export const DEFAULT_COEF = [25, 25, 25, 25];
export const SHORT = { 1: ["ΓΛ", "ΑΡ", "ΙΣ", "ΛΑ"], 2: ["ΓΛ", "ΦΥ", "ΧΗ", "ΜΑ"], 3: ["ΓΛ", "ΦΥ", "ΧΗ", "ΒΙ"], 4: ["ΓΛ", "ΜΑ", "ΠΛ", "ΟΙ"] };

export const gradesComplete = (grades) => grades.every((g) => g !== "" && !isNaN(Number(g)));
export const computeMoria = (grades, coefs) =>
  gradesComplete(grades) ? Math.round(grades.reduce((acc, g, i) => acc + Number(g) * Number(coefs[i] || 0) * 10, 0)) : null;

export default function MoriaCalculator({ field, grades, onGrades, total, reached, withCoefs }) {
  const ref = computeMoria(grades, DEFAULT_COEF);

  const setGrade = (i, v) => {
    if (v !== "" && (Number(v) < 0 || Number(v) > 20)) return;
    onGrades(grades.map((x, j) => (j === i ? v : x)));
  };

  return (
    <div data-testid="moria-calculator" className="bg-white border border-border rounded-sm p-5 md:p-6 mb-8">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <Calculator className="h-5 w-5 text-primary" strokeWidth={1.5} />
            <h3 className="font-heading font-bold text-lg">Υπολογιστής Μορίων — {field.short}</h3>
          </div>
          <p className="text-xs text-muted-foreground mb-5 leading-relaxed">
            Βάλε τους βαθμούς σου (0–20) στα 4 πανελλαδικά μαθήματα. Τα μόρια υπολογίζονται <strong>αυτόματα για κάθε σχολή</strong> με τους
            επίσημους συντελεστές βαρύτητας του Τμήματος (ΥΑ Φ.253.1/168266/Α5, ΦΕΚ 7145/Β/2025) και εμφανίζονται δίπλα στη βάση της.
          </p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {field.subjects.map((sub, i) => (
              <div key={sub} className="border border-border rounded-sm p-3">
                <div className="font-mono-accent text-[10px] uppercase tracking-widest text-muted-foreground mb-2 truncate" title={sub}>
                  <span className="text-primary font-bold">{SHORT[field.id][i]}</span> · {sub}
                </div>
                <input
                  data-testid={`moria-grade-${i}`}
                  type="number" min="0" max="20" step="0.1" inputMode="decimal" placeholder="0–20"
                  value={grades[i]} onChange={(e) => setGrade(i, e.target.value)}
                  className="w-full h-11 px-3 border border-border rounded-sm font-heading font-bold text-xl focus:outline-none focus:border-primary"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="md:w-72 shrink-0 bg-primary text-primary-foreground rounded-sm p-5 flex flex-col">
          <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/60">Μόρια με ισοβαρείς συντελεστές (25%)</div>
          <div data-testid="moria-result" className="font-heading font-extrabold text-4xl leading-none mt-2">{ref == null ? "—" : fmt(ref)}</div>
          <div className="mt-4 pt-4 border-t border-white/20 text-sm leading-relaxed">
            {ref == null
              ? <span className="text-white/70">Συμπλήρωσε και τα 4 μαθήματα.</span>
              : <span data-testid="moria-reached">«Πιάνεις» <strong>{reached}</strong> από <strong>{total}</strong> σχολές του πεδίου — με τους συντελεστές κάθε σχολής ({withCoefs} από {total} έχουν επίσημους συντελεστές).</span>}
          </div>
          <button
            data-testid="moria-reset"
            onClick={() => onGrades(["", "", "", ""])}
            className="mt-auto pt-4 inline-flex items-center gap-1.5 font-mono-accent text-[10px] uppercase tracking-widest text-white/70 hover:text-white transition-colors"
          >
            <RotateCcw className="h-3 w-3" /> Καθαρισμός
          </button>
        </div>
      </div>
    </div>
  );
}
